import { Box } from '@spark-web/box';
import { useScrollIntoView } from './hooks';

type Props = {
  enabled?: boolean;
};

function ScrollIntoView({ enabled }: Props) {
  const { ref } = useScrollIntoView(enabled);

  return <Box ref={ref} height="full" />;
}

export default ScrollIntoView;
